import { Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const EmploymentTitleField = () => {
    const { t } = useTranslation(`signup`)
    return (
        <Typography variant="body1" paddingTop={2}>
            <strong>{ t(`employment_title`) }</strong>
        </Typography>
    )
}

export { EmploymentTitleField }